import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NotificationViewModel } from '@shared/models/notifications.view-model';
import { NotificationsService } from '@shared/services/notifications.service';
import { APP_ROOT } from '../../../../../config/app-urls';

@Component({
    selector: 'app-notification-item',
    templateUrl: './notification-item.component.html',
    styleUrls: ['./notification-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, AngularSvgIconModule]
})
export class NotificationItemComponent {
  private readonly router = inject(Router);
  private readonly notificationsService = inject(NotificationsService);

  public readonly notification = input.required<NotificationViewModel>();

  async notificationClicked(): Promise<void> {
    // In order to reload a route with the same URL, we need to trick the Angular router
    // By default the router ignores same URL navigation
    // The preferred way of telling the router to reload same URL routes is to do the following:
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    // this.router.onSameUrlNavigation = 'reload';
    // However, since the router is a singleton, this has application wide implications
    // https://angular.io/api/router/ExtraOptions
    const notificationValue = this.notification();
    await this.router.navigate(APP_ROOT.toRouterLinkCommands(), {skipLocationChange: true});
    await this.router.navigate(notificationValue.routerLinkCommands);
    this.notificationsService.markNotificationTypeAsRead(notificationValue.type);
  }

}
